import './ModelViewer.css';

const ModelViewer = () => {
    return (<iframe
        title="reydar-viewer"
        className="reydar-viewer-frame"
        frameBorder="0"
        allowFullScreen=""
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        allow="autoplay; fullscreen; xr-spatial-tracking; clipboard-write;"
        xr-spatial-tracking=""
        execution-while-out-of-viewport=""
        execution-while-not-rendered=""
        web-share=""
        width="100%"
        height="100%"
        src="https://reybeam.reydar.com/?config_uuid=65423899-323b-4619-bf8a-fd868908c536"
      ></iframe>);
}
 
export default ModelViewer;